import React from 'react';

import { OFFER_STATUS } from 'utils';

/** Reddedildi, İptal Edildi, Terk Edildi: süreci bitmiş maddede işaret değişikliğinin etkisi yok. */
const CLOSED_STATUSES = [18, 45, 46];

/**
 * Yazarın `isForeign` işareti değişince süreci değişecek maddeler. BE `hasForeignAuthor`'ı her istekte
 * yazarların işaretinden hesaplar; maddede başka bir yabancı yazar varsa madde süreçte kalır.
 *
 * @param offers - `GET /article_offers?authors.author.id=` yanıtı
 * @param authorId - İşareti değişen yazar
 */
export const getForeignAffectedOffers = (offers, authorId) =>
  offers.filter((offer) => !CLOSED_STATUSES.includes(offer.status) && !offer.authors?.some(({ author }) => author?.id !== authorId && author?.isForeign));

/**
 * Onay modalındaki madde listesi. `Modal.confirm` router/intl ağacının dışında render edildiği için
 * `Link` yerine düz `a` ve önceden çevrilmiş metinler kullanılır.
 */
const ForeignAuthorAffectedOffers = ({ offers, notes }) => (
  <>
    {offers.length > 0 && (
      <ul
        className="gx-pl-4"
        style={{ maxHeight: 320, overflowY: 'auto' }}
      >
        {offers.map((offer) => (
          <li key={offer.id}>
            <a
              href={`/madde-detay/${offer.id}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {offer.title}
            </a>
            <span className="gx-text-grey"> — {OFFER_STATUS[offer.status] ?? offer.status}</span>
          </li>
        ))}
      </ul>
    )}
    {notes.length > 0 && (
      <ul className="gx-mb-0 gx-pl-4 gx-text-grey">
        {notes.map((note) => (
          <li key={note}>{note}</li>
        ))}
      </ul>
    )}
  </>
);

export default ForeignAuthorAffectedOffers;
